import { render, staticRenderFns } from "./add-user-modal.vue?vue&type=template&id=b0e87dd4&scoped=true"
import script from "./add-user-modal.vue?vue&type=script&lang=js"
export * from "./add-user-modal.vue?vue&type=script&lang=js"
import style0 from "./add-user-modal.vue?vue&type=style&index=0&id=b0e87dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e87dd4",
  null
  
)

export default component.exports